import Header from '../components/global/header'
import DMVHero from '../components/dmv/dmv-hero'
import Footer from '../components/global/footer'

function DMV() {
    return (
  <>
    <Header/>
    <DMVHero/>
    <Footer/>
  </>
    );
  }
  
  export default DMV;
  